import { OnDestroy, OnInit, Component } from '@angular/core';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-reason',
  styleUrls: ['modal-reason.style.scss'],
  templateUrl: 'modal-reason.template.html'
})
export class ModalReasonComponent implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private formReason: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<string>;
  private reason: string;
  constructor(private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private bsModalRef: BsModalRef) {
    this.initializeFormReason();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.formReason.get('reason').setValue(this.reason);
  }
  private initializeFormReason() {
    this.formReason = this.formBuilder.group({
      reason: [null, [Validators.required, Validators.maxLength(250)]]
    });
  }
  private submitForm(): void {
    if (this.formReason.valid) {
      this.update();
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
      this.configGeneral.touchedControls(this.formReason);
    }
  }
  private update(): void {
    this.reason = this.formReason.value.reason;
    this.onClose.next(this.reason);
    this.bsModalRef.hide();
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
}